import { Checkbox, Flex, Typography } from 'antd'
import { SECTION_KEYS, SECTION_LABELS } from './types'
import type { SectionKey } from './types'
import { TYPOGRAPHY } from '../../styles/theme'

const { Text } = Typography

interface SectionVisibilityControlsProps {
  isVisible: (key: SectionKey) => boolean
  toggleSection: (key: SectionKey) => void
}

export function SectionVisibilityControls({
  isVisible,
  toggleSection,
}: SectionVisibilityControlsProps) {
  return (
    <div>
      <Text
        type="secondary"
        style={{ fontSize: TYPOGRAPHY.caption.fontSize, display: 'block', marginBottom: 6 }}
      >
        Show sections
      </Text>
      <Flex wrap gap="middle">
        {SECTION_KEYS.map((key) => (
          <Checkbox key={key} checked={isVisible(key)} onChange={() => toggleSection(key)}>
            {SECTION_LABELS[key]}
          </Checkbox>
        ))}
      </Flex>
    </div>
  )
}
